import { DominoGetSettlementTypeReport } from 'apiConnector/secondary-market/reports';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

import type { ClientData } from './client.model';

export type SecondaryMarketCpFormLinkedToClientActions =
  | SecondaryMarketCpFormLinkedToClientRequested
  | SecondaryMarketCpFormLinkedToClientReceived
  | SecondaryMarketCpOrderSettlementTypeReferentialReset
  | SecondaryMarketCpFormLinkedToClientFailed
  | SecondaryMarketCpFormSettlementTypesRequested
  | SecondaryMarketCpOrderSettlementTypesFailed;

//////////////////////////////////////

export function secondaryMarketCpFormLinkedToClientRequested(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_CP_FORM_LINKED_TO_CLIENT_FETCH_REQUESTED' as const,
    tabId,
  };
}
export type SecondaryMarketCpFormLinkedToClientRequested = ReturnType<
  typeof secondaryMarketCpFormLinkedToClientRequested
>;

//////////////////////////////////////

export function secondaryMarketCpFormLinkedToClientReceived(
  tabId: string,
  data: ClientData,
  settlementTypeError?: DominoGetSettlementTypeReport,
) {
  return {
    type: 'SECONDARY_MARKET_CP_FORM_LINKED_TO_CLIENT_RECEIVED' as const,
    tabId,
    data,
    settlementTypeError,
  };
}
export type SecondaryMarketCpFormLinkedToClientReceived = ReturnType<
  typeof secondaryMarketCpFormLinkedToClientReceived
>;

//////////////////////////////////////

export function secondaryMarketCpOrderSettlementTypeReferentialReset(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_SETTLEMENT_TYPE_REFERENTIAL_RESET' as const,
    tabId,
  };
}
export type SecondaryMarketCpOrderSettlementTypeReferentialReset = ReturnType<
  typeof secondaryMarketCpOrderSettlementTypeReferentialReset
>;

///////////////////////////////////////////////

export function secondaryMarketCpFormLinkedToClientFailed(
  tabId: string,
  bcsProductKey: BcsProductKey,
  message: string,
) {
  return {
    type: 'SECONDARY_MARKET_CP_FORM_LINKED_TO_CLIENT_FAILED' as const,
    tabId,
    bcsProductKey,
    message,
  };
}

export type SecondaryMarketCpFormLinkedToClientFailed = ReturnType<typeof secondaryMarketCpFormLinkedToClientFailed>;

//////////////////////////////////////

export function secondaryMarketCpFormSettlementTypesRequested(
  tabId: string,
  bcsProductKey: BcsProductKey,
  clientBdrId: ISalesCounterpart,
  custodianBdrId: string,
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_SETTLEMENT_TYPES_FETCH_REQUESTED' as const,
    tabId,
    bcsProductKey,
    clientBdrId,
    custodianBdrId,
  };
}
export type SecondaryMarketCpFormSettlementTypesRequested = ReturnType<
  typeof secondaryMarketCpFormSettlementTypesRequested
>;

//////////////////////////////////////

export function secondaryMarketCpOrderSettlementTypesFailed(tabId: string, errorMessage?: string) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_SETTLEMENT_TYPES_FAILED' as const,
    tabId,
    errorMessage,
  };
}
export type SecondaryMarketCpOrderSettlementTypesFailed = ReturnType<
  typeof secondaryMarketCpOrderSettlementTypesFailed
>;
